export default __webpack_public_path__ + "static/media/Hackathon-request-final-1.c09423c6.gif";